export function globalPopup() {
    const $globalPopup = document.getElementById('global-popup');
    if (!$globalPopup) return;

    const $open = $globalPopup.querySelector('.open');
    const $close = $globalPopup.querySelector('.close');
    if (!$open) return;

    $open.addEventListener('click', handleOpenClick);
    $close?.addEventListener('click', handleCloseClick);

    const cmsToken = $globalPopup.dataset.token;
    let lsToken = localStorage.getItem('global-popup-token');
    let noAutoOpen = localStorage.getItem('global-popup-no-auto-open');

    // If the token is different, update the session storage
    // and allow the popup to perform the popup program
    if (!lsToken || lsToken !== cmsToken) {
        localStorage.setItem('global-popup-token', cmsToken);
        localStorage.removeItem('global-popup-no-auto-open');
        lsToken = cmsToken;
        noAutoOpen = null;
    }

    if (!noAutoOpen) {
        initPopupProgram();
    }


    // ==================== internal functions ====================
    function handleOpenClick() {
        $globalPopup.classList.add('is-open');
    }

    function handleCloseClick() {
        $globalPopup.classList.add('transition-out');
        noAutoOpen = true;
        localStorage.setItem('global-popup-no-auto-open', noAutoOpen);

        setTimeout(() => {
            $globalPopup.classList.remove('is-open', 'transition-out');
        }, 500);
    }

    function initPopupProgram() {
        const threshold = 1 / 3;

        const onScroll = () => {
            if (noAutoOpen || $globalPopup.classList.contains('is-open')) {
                window.removeEventListener('scroll', onScroll);
                return;
            }

            const scrollable = document.documentElement.scrollHeight - window.innerHeight;
            const progress = scrollable <= 0 ? 1 : window.scrollY / scrollable;

            if (progress >= threshold) {
                window.removeEventListener('scroll', onScroll);
                noAutoOpen = true;
                localStorage.setItem('global-popup-no-auto-open', noAutoOpen);
                handleOpenClick();
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }
}